import { createLocalAudioTrack, LocalAudioTrack, Room } from 'twilio-video'
import { from, Observable, throwError } from 'rxjs'
import uuidv4 from 'uuid/v4'
import { removeAudioTrack } from '../../../actions/tracks/trackActions'

/**
 * Creates a local audio track
 * @param deviceId - The device ID to generate the track for
 * @param BTID - The BrightTALK user ID
 */
export async function createTrack (room: Room, deviceId = '', BTID: string): Promise<boolean | Error> {

  let localTrack: LocalAudioTrack

  const name = `${BTID}-audio-${uuidv4()}`

  try {

    const createLocalTrackOptions = {
      name
    }
    if (deviceId) createLocalTrackOptions['deviceId'] = deviceId
    localTrack = await createLocalAudioTrack(createLocalTrackOptions)

  }
  catch (e) {

    throw e

  }

  try {

    await removeAudioTrack(room)

  }
  catch (e) {

    throw e

  }

  try {

    await room.localParticipant.publishTrack(localTrack)
    return true

  }
  catch (e) {

    throw e

  }

}

export default function (room: Room | null, deviceId: string, BTID: string | null): Observable<boolean | Error> {

  if (!room || !BTID) return throwError(new Error('Required data missing'))
  return from(createTrack(room, deviceId, BTID))

}
